export default "__VITE_ASSET__96c3dd80__"